var React = require('react');

function Car (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.0929 1.96426C10.7328 1.36904 10.0854 1 9.38197 1H2.61803L2.4568 1.00649C1.76336 1.06242 1.14376 1.4764 0.82918 2.10557L0.316718 3.1305L0.220937 3.34217C0.0753023 3.70035 0 4.08402 0 4.47214V11H3V10H9V11H12V4.47214L11.991 4.23997C11.9611 3.85448 11.8569 3.47763 11.6833 3.1305L11.1708 2.10557L11.0929 1.96426ZM1 8C1 7.44772 1.44772 7 2 7C2.55228 7 3 7.44772 3 8C3 8.55228 2.55228 9 2 9C1.44772 9 1 8.55228 1 8ZM10 7C9.44771 7 9 7.44772 9 8C9 8.55228 9.44771 9 10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7ZM2.61803 3H9.38197L9.89443 4.02492L9.94021 4.13155L9.97325 4.24238C9.99096 4.31742 10 4.39451 10 4.47214V6H2V4.47214L2.00673 4.35629C2.02015 4.24123 2.0535 4.12906 2.10557 4.02492L2.61803 3Z","fill":"#424242"}));
}

Car.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Car;

Car.default = Car;
